module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_wemakeprice.bff69e47b3c0407d7b9a7c3119da9833.png";